// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invalid-ads-records ul {\n  padding-left: 18px;\n}\n.invalid-ads-records li {\n  padding: 8px 0;\n}\n.invalid-ads-records li span {\n  font-weight: bold;\n}\n.invalid-ads-records code.error {\n  background-color: #f8d7da;\n}\n.invalid-ads-records code {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  white-space: nowrap;\n  padding: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
